class ContentTabSet {
    constructor({ wrapperId, panelsSelector }) {
        this.wrapper = document.getElementById(wrapperId);
        this.triggers = Array.from(this.wrapper.querySelectorAll("[data-content-tab]"));
        this.panels = Array.from(this.wrapper.querySelectorAll(panelsSelector));
        this.onInit();
    }

    onInit = () => {
        this.triggers.forEach(trigger => trigger.addEventListener("click", this.handleTriggerClick))
    }

    handleTriggerClick = (e) => {
        e.preventDefault();
        const navItemClicked = e.target.getAttribute("[data-content-tab]")
            ? e.target
            : e.target.parentElement;

        const tabToShowId = navItemClicked.getAttribute("data-content-tab");
        const tabToShow = this.panels.filter(panel => panel.id === tabToShowId)[0];
        const noop = navItemClicked.classList.contains("active") || !tabToShowId || !tabToShow;

        if (noop) return

        this.triggers.forEach(trigger => trigger.classList.remove("active"));
        this.panels.forEach(panel => panel.classList.remove("active"));

        navItemClicked.classList.add("active");
        tabToShow.classList.add("active");
    }
}